module.exports = __webpack_public_path__ + "img/ring_g_0_null_1.b497e253.png";